import { render, staticRenderFns } from "./brandTheme.vue?vue&type=template&id=fcfe2fae&"
import script from "./brandTheme.vue?vue&type=script&lang=js&"
export * from "./brandTheme.vue?vue&type=script&lang=js&"
import style0 from "./brandTheme.vue?vue&type=style&index=0&id=fcfe2fae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports